import { render, staticRenderFns } from "./import-substitution-offer-card.vue?vue&type=template&id=62734243&scoped=true&"
import script from "./import-substitution-offer-card.vue?vue&type=script&lang=js&"
export * from "./import-substitution-offer-card.vue?vue&type=script&lang=js&"
import style0 from "./import-substitution-offer-card.vue?vue&type=style&index=0&id=62734243&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62734243",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62734243')) {
      api.createRecord('62734243', component.options)
    } else {
      api.reload('62734243', component.options)
    }
    module.hot.accept("./import-substitution-offer-card.vue?vue&type=template&id=62734243&scoped=true&", function () {
      api.rerender('62734243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-offer-card.vue"
export default component.exports